import {
  type LoadUploadPreviewParams,
  UPLOAD_PREVIEW_LOAD_TIMEOUT_MS,
  UPLOAD_PREVIEW_SIZE,
} from './loadUploadImagePreview';

export type LoadUploadVideoPreviewParams = LoadUploadPreviewParams & {
  ext: string;
};

export const loadUploadVideoPreview = ({
  canvas,
  ctx,
  ext,
  objectUrl,
  onError,
  onPreview,
}: LoadUploadVideoPreviewParams) => {
  const video = document.createElement('video');
  video.preload = 'auto';
  const source = document.createElement('source');
  source.src = objectUrl;
  source.type = `video/${ext}`;
  video.appendChild(source);

  let settled = false;
  let loadTimeoutId = 0;

  const settle = (callback: () => void) => {
    if (settled) {
      return;
    }

    settled = true;
    window.clearTimeout(loadTimeoutId);
    callback();
  };

  loadTimeoutId = window.setTimeout(() => {
    settle(onError);
  }, UPLOAD_PREVIEW_LOAD_TIMEOUT_MS);

  const handleLoadedData = () => {
    settle(() => {
      if (!video.videoWidth || !video.videoHeight) {
        onError();
        return;
      }

      try {
        const videoRatio = video.videoWidth / video.videoHeight;
        canvas.height = UPLOAD_PREVIEW_SIZE;
        canvas.width = UPLOAD_PREVIEW_SIZE * videoRatio;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        onPreview(canvas.toDataURL());
      } catch {
        onError();
      }
    });
  };

  const handleError = () => {
    settle(onError);
  };

  video.addEventListener('loadeddata', handleLoadedData);
  video.addEventListener('error', handleError);
  source.addEventListener('error', handleError);
  video.load();

  return () => {
    settled = true;
    window.clearTimeout(loadTimeoutId);
    video.removeEventListener('loadeddata', handleLoadedData);
    video.removeEventListener('error', handleError);
    source.removeEventListener('error', handleError);
    video.pause();
    source.remove();
    video.load();
  };
};
